export default __webpack_public_path__ + "static/media/qr-icon.7f1e12e6.svg";